import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Login from "../pages/Login";
import Register from "../pages/Register";

import Step1Type from "../pages/CreateStore/Step1Type";
import Step2Individual from "../pages/CreateStore/Step2Individual";
import Step2Company from "../pages/CreateStore/Step2Company";
import Step3Address from "../pages/CreateStore/Step3Address";
import Step4Details from "../pages/CreateStore/Step4Details";
import Step5CNAE from "../pages/CreateStore/Step5CNAE";

import Dashboard from "../pages/Dashboard/Dashboard";

import TodosPedidos from "../pages/Dashboard/Settings/pedidos/Todos_os_pedidos";
import RegistrarPedido from "../pages/Dashboard/Settings/pedidos/Registrar_pedido";
import LeitorCodigos from "../pages/Dashboard/Settings/pedidos/Leitor_codigos";
import EmissaoNotas from "../pages/Dashboard/Settings/pedidos/Emissao_notas";
import Estatisticas from "../pages/Dashboard/Settings/pedidos/Estatisticas";

import Pedidos from "../pages/Dashboard/Settings/mercadoria/Pedidos";
import Categorias from "../pages/Dashboard/Settings/mercadoria/Categorias";
import Producao from "../pages/Dashboard/Settings/mercadoria/Producao";
import Produtos from "../pages/Dashboard/Settings/mercadoria/Produtos";
import RegistrarDevolucao from "../pages/Dashboard/Settings/mercadoria/Registrar_devolucao";

import Perfil from "../pages/Dashboard/Settings/loja/Perfil";
import Informacoesfiscais from "../pages/Dashboard/Settings/loja/Informacoes_fiscais";
import Faturamento from "../pages/Dashboard/Settings/loja/Faturamento";
import Documentos from "../pages/Dashboard/Settings/loja/Documentos";
import Descontos from "../pages/Dashboard/Settings/loja/Descontos";
import Formaspagamento from "../pages/Dashboard/Settings/loja/Formas_pagamento";
import Metodosenvio from "../pages/Dashboard/Settings/loja/Metodos_envio";
import Horarios from "../pages/Dashboard/Settings/loja/Horarios";
import Perguntas from "../pages/Dashboard/Settings/loja/Perguntas";
import Contavendedor from "../pages/conta_do_vendedor";

import Totem from "../pages/Dashboard/Settings/gepprostore/Gerenciar_totens";

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Dashboard protegido - requer autenticação */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

        <Route path="/create-store/step1" element={<Step1Type />} />
        <Route path="/create-store/step2-individual" element={<Step2Individual />} />
        <Route path="/create-store/step2-company" element={<Step2Company />} />
        <Route path="/create-store/step3" element={<Step3Address />} />
        <Route path="/create-store/step4" element={<Step4Details />} />
        <Route path="/create-store/step5" element={<Step5CNAE />} />

        {/* Rotas protegidas - Pedidos */}
        <Route path="/Todos_os_pedidos" element={<ProtectedRoute><TodosPedidos /></ProtectedRoute>} />
        <Route path="/Registrar_pedido" element={<ProtectedRoute><RegistrarPedido /></ProtectedRoute>} />
        <Route path="/Leitor_codigos" element={<ProtectedRoute><LeitorCodigos /></ProtectedRoute>} />
        <Route path="/Emissao_notas" element={<ProtectedRoute><EmissaoNotas /></ProtectedRoute>} />
        <Route path="/Estatisticas" element={<ProtectedRoute><Estatisticas /></ProtectedRoute>} />

        {/* Rotas protegidas - Mercadoria */}
        <Route path="/Pedidos" element={<ProtectedRoute><Pedidos /></ProtectedRoute>} />
        <Route path="/Categorias" element={<ProtectedRoute><Categorias /></ProtectedRoute>} />
        <Route path="/Producao" element={<ProtectedRoute><Producao /></ProtectedRoute>} />
        <Route path="/Produtos" element={<ProtectedRoute><Produtos /></ProtectedRoute>} />
        <Route path="/Registrar_devolucao" element={<ProtectedRoute><RegistrarDevolucao /></ProtectedRoute>} />

        {/* Rotas protegidas - Loja */}
        <Route path="/Perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />
        <Route path="/Informacoes_fiscais" element={<ProtectedRoute><Informacoesfiscais /></ProtectedRoute>} />
        <Route path="/Faturamento" element={<ProtectedRoute><Faturamento /></ProtectedRoute>} />
        <Route path="/Documentos" element={<ProtectedRoute><Documentos /></ProtectedRoute>} />
        <Route path="/Descontos" element={<ProtectedRoute><Descontos /></ProtectedRoute>} />
        <Route path="/Formas_pagamento" element={<ProtectedRoute><Formaspagamento /></ProtectedRoute>} />
        <Route path="/Metodos_envio" element={<ProtectedRoute><Metodosenvio /></ProtectedRoute>} />
        <Route path="/Horarios" element={<ProtectedRoute><Horarios /></ProtectedRoute>} />
        <Route path="/Perguntas" element={<ProtectedRoute><Perguntas /></ProtectedRoute>} />

        {/* Rotas protegidas - Geppro Store */}
        <Route path="/Gerenciar_totens" element={<ProtectedRoute><Totem /></ProtectedRoute>} />

        {/* Rotas protegidas - Conta do vendedor */}
        <Route path="/conta_do_vendedor" element={<ProtectedRoute><Contavendedor /></ProtectedRoute>} />

      </Routes>
    </Router>
  );
}
